import HomeRegister from "../components/home/HomeRegister";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

function Page({ type }) {
    return isProspect(type) ? <HomeRegister /> : <NotFound />;
}

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default Page;
